
import styled from 'styled-components';
import { useState } from 'react';
import Modal from './Modal';

const StyledModal = styled(Modal)`
main {
  text-align: center;
}
`
const ConfirmButton = ({ 
  text, 
  confirmClass = 'danger', 
  confirm = 'OK', 
  cancelClass = 'primary', 
  cancel = 'Cancel', 
  onConfirm,
  onCancel,
  children, 
  ...rest }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleClick = e => {
    e.stopPropagation();
    setModalOpen(true);
  }

  const handleConfirm = e => {
    e.stopPropagation();
    setModalOpen(false);
    onConfirm();
  }

  const handleCancel = e => {
    e.stopPropagation();
    setModalOpen(false);
    onCancel();
  }

  return (
    <>
      <button onClick={e => handleClick(e)} {...rest} >
        {children}
      </button>
      <StyledModal isOpen={isModalOpen}>
        <title>
          Confirmation
        </title>
        <main>
          {text}
        </main>
        <footer>
          { onCancel && <button className={cancelClass} onClick={e => handleCancel(e)}>{cancel}</button> }
          { onConfirm && <button className={confirmClass} onClick={e => handleConfirm(e)}>{confirm}</button>}
        </footer>
      </StyledModal>
    </>
  )
}

export default ConfirmButton;